<template>
    <div>
      <mt-popup style="border-radius:8px" v-model="isShowTips" position="center" pop-transition="popup-fade"  >
         <div class="privacy-tip-content">
             <h2 class="title">会员积分隐私政策</h2>
             <div class="tips">
                 欢迎使用会员积分,我们非常重视您的个人信息和隐私保护,请仔细阅读
                 <span @click='agreementDetail' style="color:blue">《同创会员积分隐私政策》,</span>
                 我们将严格按照经您同意的各项条款使用您的个人信息,以便为您提供更好的服务,
                 请您同意此政策和协议
             </div>
             <div class="bottom">
                 <div @click="Dontagree" class="item" style="border-right:1px solid #ccc">不同意</div>
                 <div @click="agree" class="item">同意</div>
             </div>
         </div>
      </mt-popup>
    </div>
</template>
<script>
import {pointAgree} from '../../../utils/api'
export default {
    data () {
        return {
            isShowTips: false,

        }
    },
    methods:{
        openDialog () {
            this.isShowTips = true
        },
        closeDialog () {
            this.isShowTips = false
        },
        Dontagree () {
           this.closeDialog()
        },
        agree () {
          //跳转积分商城
           pointAgree().then(res => {
               console.log(res,'resss')
               if (res.res.code === 10000) {
                   this.closeDialog()
                   this.$router.push({
                       path:'/IntegralMall'
                   })
                }
          })
        },
        agreementDetail () {
           let id = process.env.VUE_APP_APP_HOST ? '4F3DB5C2C99A4F3C8969510703E1164E': '2D644A80E5BE456D9C640A4B36D30F5A&VNK=7c0a8009'
           let url =`/policyDetail?id=${id}`
           this.$router.push({path:url})
        }

    }
}
</script>
<style lang="less" scoped>
.privacy-tip-content{
  width:580px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  .title{
      color: #303133;
      font-weight: 600;
      margin-top: 48px;
  }
  .tips{
      margin: 48px 24px;
      text-indent:24px;
      line-height: 40px;
  }
  .bottom{
      display: flex;
      height: 70px;
      width: 100%;
      border-top: 1px solid #ccc;
      .item{
          flex: 1;
          text-align: center;
          line-height: 70px;
      }
  }
}
</style>